/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { InternalAuthTokensV1FromJSON, } from '../models/index';
/**
 *
 */
export class AuthApi extends runtime.BaseAPI {
    /**
     * Refreshes the access and refresh tokens using the `api_refresh_token_admin` cookie. New tokens are returned in the JSON response and also set as cookies.
     * Refresh admin access and refresh tokens
     */
    internalRefreshAuthAdminTokensRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/auth/v1/refresh_admin_tokens`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAuthTokensV1FromJSON(jsonValue));
        });
    }
    /**
     * Refreshes the access and refresh tokens using the `api_refresh_token_admin` cookie. New tokens are returned in the JSON response and also set as cookies.
     * Refresh admin access and refresh tokens
     */
    internalRefreshAuthAdminTokens(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalRefreshAuthAdminTokensRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     * Refreshes the access and refresh tokens using the `api_refresh_token` cookie. New tokens are returned in the JSON response and also set as cookies.
     * Refresh access and refresh tokens
     */
    internalRefreshAuthTokensRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            let urlPath = `/internal/auth/v1/refresh_tokens`;
            const response = yield this.request({
                path: urlPath,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => InternalAuthTokensV1FromJSON(jsonValue));
        });
    }
    /**
     * Refreshes the access and refresh tokens using the `api_refresh_token` cookie. New tokens are returned in the JSON response and also set as cookies.
     * Refresh access and refresh tokens
     */
    internalRefreshAuthTokens(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.internalRefreshAuthTokensRaw(initOverrides);
            return yield response.value();
        });
    }
}
